import 'whatwg-fetch';

const serializeToQuerystring = (urlParams) => Object.keys(urlParams).reduce((accumulator, currentValue) => `${accumulator}&${currentValue}=${urlParams[currentValue]}`, '');

const getResponse = (url, urlParams) => fetch(`${url}?${serializeToQuerystring(urlParams)}`, { method: 'get', credentials: 'same-origin' })
  .then((r) => (r.ok ? r : Promise.reject(r)));

const getJson = (url, urlParams = {}) => getResponse(url, urlParams).then((r) => r.json());

const postJson = (apiRoot, body) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return fetch(apiRoot, { headers, method: 'post', credentials: 'same-origin', body: JSON.stringify(body) }).then(r => (r.ok ? r : Promise.reject(r)));
};

const deleteJson = (apiRoot) => fetch(apiRoot, { method: 'delete', credentials: 'same-origin' }).then(r => (r.ok ? r : Promise.reject(r)));

const WebAPI = {
  profile: {
    getBalance(params) {
      return getJson('/api/payments/v2/global/buyer/balance/', params);
    },
    getCards(params) {
      return getJson('/api/payments/v1/card-details/', params);
    },
    deleteCard() {
      return deleteJson('/api/payments/v1/card-details/');
    },
  },
  downloads: {
    getDownloadedResources(params) {
      return getJson('/api/v2/my-resources/downloads', params);
    },
  },
  reviews: {
    getUnreviewedResources(params) {
      return getJson('/api/v2/my-resources/downloads/unreviewed', params);
    },
    submitReview(params) {
      return postJson('/api/v2/my-resources/review/', params);
    },
    getNumOfCommentedReviews() {
      return getJson('/api/v2/my-resources/getNumOfCommentedReviews');
    },
    getReviewReasons() {
      return getJson('/api/v2/my-resources/getReviewReasons');
    },
  },
  bought: {
    getBoughtResources(params) {
      return getJson('/api/v2/my-resources/bought', params);
    },
  },
  saved: {
    getSavedResources(params) {
      return getJson('/api/v2/my-resources/saved', params);
    },
    deleteSavedResource(resourceId) {
      return postJson('/api/favourites/v1/remove', { applicationId: Number(resourceId) });
    },
  },
};

export default function createWebAPI() {
  return WebAPI;
}
